import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { Button } from "../../../stories/Button/Button";
import css from "./BecomeAnInvestor.module.css";
import {
  logo,
  quotationMark,
  corporateOverview,
  ourAchievements,
  instantMessaging,
  HeadingBg,
  ArrowUpRightWhite,
} from "../../../constant/imagePath";
import { Input } from "../../../stories/Input/Input";
import { Checkbox } from "../../../stories/Checkbox/Checkbox";
import { Footer } from "../../../stories/Footer/Footer";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import BecomeAnInvestorMobile from "./BecomeAnInvestorMobile";

function BecomeAnInvestorDesktop() {
  const [email, setEmail] = useState("");
  const [checkBoxes, setCheckBoxes] = useState(["Presentations", "Event"]);
  return (
    <div>
      <Container fluid className="p-0">
        <Row className="g-0">
          {/* First Section Head Container*/}
          <Col md={12}>
            <div className={css.headSection}>
              <AfterLoginHeader
                isWhite
                icon={logo}
                getAMatchIcon={ArrowUpRightWhite}
                className={css.container}
              />

              <Container fluid className={`p-0 ${[css.container].join(" ")}`}>
                <div className={css.headSectionText}>
                  <Row className="g-0" style={{ width: "100%" }}>
                    <Col md={8}>
                      <h6
                        style={{
                          ...Fonts.h1,
                          color: "#ffffff",
                          textTransform: "uppercase",
                          letterSpacing: "-0.5px",
                        }}
                      >
                        <span>Become an </span>
                        <span className={css.headingBg}>
                          &nbsp;&nbsp;investor&nbsp;&nbsp;&nbsp;
                          <img src={HeadingBg} />
                        </span>

                        {/* Become An
                        <span className={css.headingBg}>
                          &nbsp;Investor
                          <img src={HeadingBg} alt="" />
                          &nbsp;&nbsp;
                        </span> */}
                      </h6>
                    </Col>

                    <Col md={4}>
                      <div className={css.taglineWithButton}>
                        <p
                          className={css.tagline}
                          style={{ color: Colors.white, ...Fonts.p1 }}
                        >
                          We are looking for experienced individuals to join our
                          national team of talented sports coaches.
                        </p>
                        <Button
                          label="Apply Now"
                          primary={true}
                          size={"Large"}
                          customStyle={{
                            width: "200px",
                            height: "56px",
                            marginTop: "24px",
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
              </Container>
            </div>
          </Col>
          <Col md={12}>
            <div className={css.sec2OurMissionMainContainer}>
              <Container
                fluid
                className={`p-0 ${[css.container, css.sec2bodyMain].join(" ")}`}
              >
                <Col md={12}>
                  <h1
                    style={{ ...Fonts.h2, color: Colors.neutralShadesOfNero }}
                  >
                    Our
                    <span className={css.headingBg}>
                      &nbsp;&nbsp;mission&nbsp;&nbsp;
                      <img src={HeadingBg} alt="" />
                    </span>
                  </h1>
                </Col>
                <Row className={css.sec2Body}>
                  <Col md={4}>
                    <img src={quotationMark} alt="" />
                  </Col>
                  <Col md={8}>
                    <p
                      style={{
                        ...Fonts.h4,
                        fontSize: "26px",
                        color: Colors.neutralShadesOfNero,
                      }}
                    >
                      I am very fond of the idea of CoachUp and enthusiastic
                      about it. Anytime you can have extra training, guidance,
                      and help in something that you enjoy doing, and in which
                      you have shown the capacity to improve, its a great thing.
                    </p>
                    <div className={css.sec2NameAndDesignation}>
                      <p
                        style={{
                          ...Fonts.h5,
                          color: Colors.neutralShadesOfNero,
                          marginBottom: "8px",
                        }}
                      >
                        Jason Ngo
                      </p>
                      <p
                        style={{
                          ...Fonts.p1,
                          color: Colors.neutralShadesOfDimGray,
                        }}
                      >
                        CEO and co-founder, Lytesnap
                      </p>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </Col>
          <Col md={12}>
            <Container fluid className={`p-0 ${[css.container].join(" ")}`}>
              <Row className={`g-0 ${[css.sec3MainContainer].join(" ")}`}>
                <Col md={7}>
                  <div className={css.section3Content}>
                    <p
                      style={{
                        ...Fonts.h2,
                        color: Colors.neutralShadesOfNero,
                        marginBottom: "24px",
                      }}
                    >
                      Corporate overview
                    </p>
                    <p
                      style={{
                        ...Fonts.p1,
                        color: Colors.neutralShadesOfDimGray,
                      }}
                    >
                      Recruit Look regularly talks about the things each
                      potential recruit needs to accomplish to maximize their
                      chances of landing an athletic scholarship. Please make
                      sure to avoid these mistakes…mostly caused from massive
                      misinformation out there. Keep in mind, sometimes what you
                      don’t say is just as important as what you do.
                    </p>
                  </div>
                </Col>
                <Col md={5}>
                  <div className={css.sec3Image}>
                    <img src={corporateOverview} alt="corporateOverview" />
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
          <Col md={12} className={css.ourAchievementContainer}>
            <div className={css.sec4MainContainer}>
              <Container fluid className={`p-0 ${[css.container].join(" ")}`}>
                <Col md={12}>
                  <h2
                    style={{
                      ...Fonts.h2,
                      color: Colors.white,
                      letterSpacing: "-0.5px",
                    }}
                  >
                    Our&nbsp;
                    <span className={css.headingBg}>
                      &nbsp;achievements
                      <img src={HeadingBg} alt="" />
                    </span>
                  </h2>
                </Col>
                <Row className={css.sec4Body}>
                  <Col md={4}>
                    <div className={css.seperator}>
                      <p style={{ ...Fonts.h3, color: Colors.white }}>1000</p>
                      <p style={{ ...Fonts.p1, color: Colors.white }}>
                        All of our coaches have extensive coaching experience
                        and are required to pass rigorous background checks.
                      </p>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className={css.seperator}>
                      <p style={{ ...Fonts.h3, color: Colors.white }}>500</p>
                      <p style={{ ...Fonts.p1, color: Colors.white }}>
                        Every coaching session can be booked in minutes through
                        Lytesnap and all financial transactions are processed
                        online.
                      </p>
                    </div>
                  </Col>{" "}
                  <Col md={4}>
                    <div className={css.seperator}>
                      <p style={{ ...Fonts.h3, color: Colors.white }}>13,492</p>
                      <p style={{ ...Fonts.p1, color: Colors.white }}>
                        We are committed to helping you find the right coach,
                        and we back that up with our 100% money-back guarantee.
                      </p>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </Col>
          <Col md={12}>
            <div className={css.sec5MainContainer}>
              <Container fluid className={`p-0 ${[css.container].join(" ")}`}>
                <Col md={6}>
                  <p style={{ ...Fonts.h2, color: Colors.neutralShadesOfNero }}>
                    Email Alerts and Contact Info
                  </p>
                </Col>
                <Row className={css.sec5Body}>
                  <Col md={6}>
                    <div className={css.sec5leftDivBox}>
                      <div>
                        <Input
                          placeholder={"Your email"}
                          state={email}
                          setter={setEmail}
                        />
                      </div>
                      <div style={{ display: "flex", marginTop: "24px" }}>
                        <Checkbox
                          label="Presentations"
                          value={checkBoxes}
                          setValue={setCheckBoxes}
                          labelStyle={{ fontSize: "14px" }}
                        />
                        <span style={{ marginLeft: "47px" }}>
                          <Checkbox
                            label="Event"
                            value={checkBoxes}
                            setValue={setCheckBoxes}
                            labelStyle={{ fontSize: "14px" }}
                          />
                        </span>
                      </div>
                      <div className={css.submitBtn}>
                        <Button
                          size={"Large"}
                          primary={true}
                          label="Submit"
                          customStyle={{ width: "100%", marginTop: "40px" }}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col md={2}></Col>
                  <Col md={4} className={css.sec5RightContainer}>
                    <div className={css.sec5Image}>
                      <img src={instantMessaging} alt="" />
                    </div>
                    <p
                      style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
                    >
                      Questions for the Investor Relations department can be
                      emailed to{" "}
                      <a
                        className={[css.textdecor].join(" ")}
                        style={{ color: Colors.mainBlue }}
                        href="mailto:lytesnap@com"
                      >
                        lytesnap@com
                      </a>{" "}
                      or submitted by clicking on the button below.
                    </p>
                    <Button
                      primary={false}
                      label="Contact Us"
                      size="Large"
                      customStyle={{
                        marginTop: "56px",
                        width: "162px",
                        height: "56px",
                      }}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          </Col>
          <Col md={12}>
            <Footer className={css.container} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

function BecomeAnInvestor() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <BecomeAnInvestorMobile /> : <BecomeAnInvestorDesktop />;
}

export default BecomeAnInvestor;
